import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'

export const useBylineStore = defineStore('byline', {
  state: () => ({
    byline: {
      id:  null,
      publication_id: null,
      title: null,
      web_content: null,
      print_content: null,
      attribution: null,
    }
  }),

  actions: {
    async fetch({ bylineId }) {
      if(!bylineId) { return Promise.resolve() }

      return httpClient.get(`/api/internal/bylines/${bylineId}`)
        .then(({ data: { byline } }) => {
          this.byline = byline
        })
    }
  }
})
